// src/client/game/core/enemy/controllers/AggroController.ts
import type { EnemyController } from "../EnemyController";
import type { EnemyContext } from "../EnemyContext";
import type { Direction, GridPos } from "../../types";

const DIRS: Direction[] = [
  { dx: 0, dy: -1 },
  { dx: 1, dy: 0 },
  { dx: 0, dy: 1 },
  { dx: -1, dy: 0 },
];

/**
 * Placeholder controller for late-game enemies that chase the player.
 * Currently greedy toward player head.
 */
export class AggroController implements EnemyController {
  readonly id = "aggro";

  decideNextMove(ctx: EnemyContext): Direction {
    const head = ctx.self.snake.segments[0];
    const target = ctx.world.player.segments[0];
    const best = DIRS
      .map((d) => ({ d, p: { x: head.x + d.dx, y: head.y + d.dy } as GridPos }))
      .filter(({ p }) => !ctx.world.isBlocked(p))
      .sort((a, b) => this.dist(a.p, target) - this.dist(b.p, target))[0];

    return best?.d ?? ctx.self.snake.direction;
  }

  private dist(a: GridPos, b: GridPos): number {
    return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
  }
}
